import axios from 'axios';
import {getToken} from './token';
import Config from 'react-native-config';
import Toast from 'react-native-toast-message';
import {routeNavigate} from '../layout/Router';

const request = axios.create({
  timeout: 20000,
  baseURL: Config.BASE_URL,
});

request.interceptors.request.use(
  async config => {
    config.headers.token = await getToken();
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (
      response.config.responseType === 'arraybuffer' ||
      response.config.responseType === 'bolb'
    ) {
      return response;
    } else {
      if (res.status === 520) {
        Toast.show({
          type: 'error',
          text1: res.msg,
        });
        return Promise.reject(res);
      }
      return res;
    }
  },
  async error => {
    const status = error.response.status;
    console.log('ccc', error);
    switch (status) {
      // token 无效/不存在
      case 401: {
        console.log('401');
        routeNavigate('Login');
        break;
      }
      case 502: {
        Toast.show({
          type: 'error',
          text1: error.response.data.message,
        });
        break;
      }
      case 500: {
        Toast.show({
          type: 'error',
          text1: '服务器错误',
          text2: '请稍后重试',
        });
        break;
      }
    }
    return Promise.reject(error);
  },
);

export default request;
